<template>
  <div>
    <div v-if="dp">
      <h4>Details for {{dp.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{dp[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="dp.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "dp",
  components: {
    BFR
  },
  props: {
    dp: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["brand", "Brand"],
      ["voltageRating", "Voltage Rating"],
      ["amps", "Main/Service Size Amps"],
      ["type", "Type"],
      ["enclosure", "Enclosure"],
      ["typeOfMain", "Type of Main"],
      ["mountingType", "Mounting"],
      ["cabinetHeight", "Cabinet Height"],
      ["cabinetWidth", "Cabinet Width"],
      ["cabinetDepth", "Cabinet Depth"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
